import { useEffect, useRef, useState } from "react";
import { Icon } from "./Icon";

// curated palette of registry icons that suit project / metric tiles
const PICK_ICONS = [
  "seal-check", "vector-two", "map-pin-area", "map-pin", "polygon", "stack",
  "ruler", "scales", "gauge", "chart-bar", "chart-line", "chart-line-up",
  "chart-donut", "chart-polar", "baby-carriage", "person-simple-walk", "binoculars", "house",
  "currency-eur", "hash", "lightning", "package", "database", "globe-hemisphere-west",
  "crosshair-simple", "squares-four", "list-checks", "table", "image", "camera",
  "check-circle", "shield-star", "users-three", "square", "circle", "triangle",
];

// click → a palette opens (like a colour picker), pick one
export function IconPicker({ value, onChange, box = 38 }: { value: string; onChange: (icon: string) => void; box?: number }) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const h = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, [open]);
  return (
    <div ref={ref} style={{ position: "relative", flex: "none" }}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        title="Symbol wählen"
        className="ring-focus"
        style={{ width: box, height: box, borderRadius: 10, border: "1px solid var(--field-border)", background: "var(--accent-soft)", color: "var(--accent-text)", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <Icon name={value || "squares-four"} size={Math.round(box * 0.52)} />
      </button>
      {open && (
        <div
          className="anim-pop scroll"
          style={{ position: "absolute", top: "calc(100% + 6px)", left: 0, zIndex: 60, width: 250, maxHeight: 244, overflowY: "auto", borderRadius: 12, padding: 8, background: "var(--panel-solid)", border: "1px solid var(--glass-border-strong)", boxShadow: "var(--shadow-lg)", display: "grid", gridTemplateColumns: "repeat(6,1fr)", gap: 4 }}
        >
          {PICK_ICONS.map((ic) => {
            const on = value === ic;
            return (
              <button
                key={ic}
                type="button"
                onClick={() => { onChange(ic); setOpen(false); }}
                title={ic}
                className="ring-focus"
                style={{ aspectRatio: "1", borderRadius: 8, border: "none", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", background: on ? "var(--accent-soft)" : "transparent", color: on ? "var(--accent-text)" : "var(--text-dim)" }}
                onMouseEnter={(e) => { if (!on) e.currentTarget.style.background = "var(--hover)"; }}
                onMouseLeave={(e) => { if (!on) e.currentTarget.style.background = "transparent"; }}
              >
                <Icon name={ic} size={18} />
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
